document.addEventListener('DOMContentLoaded', () => {
    // Selectors for Desktop
    const deskForm = document.getElementById('hc-form');
    const deskAmount = document.getElementById('hc-amount');
    const deskResult = document.getElementById('hc-result-amount');
    const deskBtn = document.getElementById('hc-cta-button');

    // Selectors for Mobile
    const mobForm = document.getElementById('hc-form-mobile');
    const mobAmount = document.getElementById('hc-amount-mobile');
    const mobResult = document.getElementById('hc-result-amount-mobile');
    const mobBtn = document.getElementById('hc-cta-button-mobile');

    // Default State
    const defaultState = {
        amount: 0,
        donorType: 'particular',
        periodicity: 'mensual',
        isRecurring: false
    };

    const getState = () => {
        return JSON.parse(sessionStorage.getItem('donationCalculatorData') || JSON.stringify(defaultState));
    };

    const saveState = (newState) => {
        const current = getState();
        const updated = { ...current, ...newState };
        sessionStorage.setItem('donationCalculatorData', JSON.stringify(updated));
        render(updated);
    };

    const render = (state) => {
        // Sync Desktop
        if (deskAmount) {
            if (!deskAmount.hasAttribute('placeholder')) deskAmount.setAttribute('placeholder', '_');
            deskAmount.value = state.amount === 0 ? '' : state.amount;
        }
        if (deskForm) {
            const rad = deskForm.querySelector(`input[name="donorType"][value="${state.donorType}"]`);
            if (rad) rad.checked = true;
            const per = deskForm.querySelector(`input[name="periodicity"][value="${state.periodicity}"]`);
            if (per) per.checked = true;
            const rec = deskForm.querySelector(`input[name="isRecurring"]`);
            if (rec) rec.checked = state.isRecurring;
        }
        
        // Sync Mobile
        if (mobAmount) {
            if (!mobAmount.hasAttribute('placeholder')) mobAmount.setAttribute('placeholder', '_');
            mobAmount.value = state.amount === 0 ? '' : state.amount;
        }
        if (mobForm) {
            const rad = mobForm.querySelector(`input[name="donorType-mobile"][value="${state.donorType}"]`);
            if (rad) rad.checked = true;
            const per = mobForm.querySelector(`input[name="periodicity-mobile"][value="${state.periodicity}"]`);
            if (per) per.checked = true;
            const rec = mobForm.querySelector(`input[name="isRecurring-mobile"]`);
            if (rec) rec.checked = state.isRecurring;
        }

        // Update Results Text
        let suffix = '';
        if (state.periodicity === 'mensual') suffix = '/mes';
        else if (state.periodicity === 'trimestral') suffix = '/trim';
        else if (state.periodicity === 'anual') suffix = '/año';

        const displayAmount = state.amount === 0 ? '_' : state.amount.toLocaleString('es-ES');
        const text = `${displayAmount} €${suffix}`.replace('?', '');
        if (deskResult) deskResult.textContent = text;
        if (mobResult) mobResult.textContent = text;
    };

    // Listeners
    const bindListeners = (form, isMobile) => {
        if (!form) return;
        
        const inputs = form.querySelectorAll('input');

        inputs.forEach(input => {
            input.addEventListener('change', (e) => {
                let name = input.name;
                if (isMobile) name = name.replace('-mobile', '');
                
                let value = input.value;
                if (input.type === 'checkbox') value = input.checked;
                if (input.type === 'number') value = parseFloat(input.value) || 0;
                
                saveState({ [name]: value });
            });
            
            // For text input live update
            if (input.type === 'number') {
                input.addEventListener('input', (e) => {
                    saveState({ amount: parseFloat(e.target.value) || 0 });
                });
            }
        });
    };

    bindListeners(deskForm, false);
    bindListeners(mobForm, true);

    // Keypad functionality
    const setupKeypad = (keypadElement, inputElement) => {
        if (!keypadElement || !inputElement) return;

        const buttons = keypadElement.querySelectorAll('button[data-value]');
        buttons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const value = button.getAttribute('data-value');
                const currentValue = inputElement.value || '';
                
                // Prevent multiple decimal points
                if (value === '.' && currentValue.includes('.')) return;
                
                // Append value
                const newValue = currentValue + value;
                inputElement.value = newValue;
                
                // Trigger input event to update state
                const event = new Event('input', { bubbles: true });
                inputElement.dispatchEvent(event);

                // Remove hover state on mobile after touch
                button.blur();
            });
        });
    };

    // Setup keypads for desktop and mobile
    const deskKeypad = document.querySelector('.hc-desktop-view .hc-keypad[data-target="hc-amount"]');
    const mobKeypad = document.querySelector('.hc-mobile-view .hc-keypad[data-target="hc-amount-mobile"]');
    
    setupKeypad(deskKeypad, deskAmount);
    setupKeypad(mobKeypad, mobAmount);

    const handleRedirect = () => {
        const state = getState();
        if (state.donorType === 'empresa') {
            window.location.href = '/calculadora-resultados-empresa/';
        } else {
            window.location.href = '/calculadora-resultados/';
        }
    };

    if (deskBtn) deskBtn.addEventListener('click', (e) => { e.preventDefault(); handleRedirect(); });
    if (mobBtn) mobBtn.addEventListener('click', (e) => { e.preventDefault(); handleRedirect(); });

    // Decorative button - scroll to form section
    const decorativeBtn = document.querySelector('.hc-cta-button-decorative');
    if (decorativeBtn) {
        decorativeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const formSection = document.getElementById('hc-mobile-form-section');
            if (formSection) {
                const elementPosition = formSection.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - 60; // Offset de 60px arriba
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    }

    // Check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('donorType') === 'empresa') {
        saveState({ donorType: 'empresa' });
    } else {
        saveState({ donorType: 'particular' });
    }

    // Initial run
    render(getState());
});
